import React, { createContext, useContext, useState, useEffect } from "react";
import BrandingService from "../../API/BrandingService";
import { imageURL } from "../../Configuration/ApiConfig";
import { notification } from "antd";
import { CheckCircleOutlined } from '@ant-design/icons';

const BrandingContext = createContext();

export const BrandingProvider = ({ children }) => {
    const [brandName, setBrandName] = useState("");
    const [subtitle, setSubtitle] = useState("");
    const [logo, setLogo] = useState(null);
    const [logoFile, setLogoFile] = useState(null);
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [zipCode, setZipCode] = useState("");
    const [phone, setPhone] = useState("");
    const [isUpdating, setIsUpdating] = useState(false);
    const [id, setId] = useState();
    const [existingLogo, setExistingLogo] = useState("");
    const [onlinePayment, setOnlinePayment] = useState(false);
    const [fax, setFax] = useState("");
    const [connectedAccountId, setConnectedAccountId] = useState("");

    useEffect(() => {
        fetchBranding();
    }, []);


    const fetchBranding = async () => {
        try {
            const data = await BrandingService.GetBranding();
            if (data.resultData) {
                setBrandName(data.resultData.name);
                setSubtitle(data.resultData.subtitle);
                setAddress(data.resultData.address);
                setCity(data.resultData.city);
                setState(data.resultData.state);
                setZipCode(data.resultData.zipcode);
                setPhone(data.resultData.phone);
                setFax(data.resultData.fax);
                setId(data.resultData.id);
                setOnlinePayment(data.resultData.onlinePayment || "");
                setConnectedAccountId(data.resultData.connectedAccountId || "");
                setIsUpdating(true);

                if (data.resultData.logo) {
                    setExistingLogo(`${imageURL}${data.resultData.logo}`);
                }
            }
        } catch (error) {
            console.error("Error fetching branding:", error);
        }
    };

    const handleConnectedAccountIdChange = (e) => {
        setConnectedAccountId(e.target.value);
    };

    const handleBrandNameChange = (e) => {
        setBrandName(e.target.value);
        ValidateBrandName(e.target.value);
    };

    const handleSubtitleChange = (e) => {
        setSubtitle(e.target.value);
    };

    const handleFaxChange = (e) => {
        setFax(e.target.value);
        ValidateFax(e.target.value);
    };

    const handleOnlinePaymentChange = (event) => {
        setOnlinePayment(event.target.checked);
    };

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        if (file && (file.type === "image/jpeg" || file.type === "image/png")) {
            setLogoFile(file); // Save file for submission

            const reader = new FileReader();
            reader.onloadend = () => {
                setLogo(reader.result.split(",")[1]); // Remove data:image/png;base64 prefix
            };
            reader.readAsDataURL(file);
        }
    };

    const handleAddressChange = (e) => {
        setAddress(e.target.value);
        ValidateAddressLine(e.target.value);
    };

    const handleCityChange = (e) => {
        setCity(e.target.value);
        ValidateCity(e.target.value);
    };

    const handleStateChange = (value) => {
        setState(value);
        ValidateState(value);
    };

    const handleZipCodeChange = (e) => {
        setZipCode(e.target.value);
        ValidateZipCode(e.target.value);
    };

    const handlePhoneChange = (e) => {
        setPhone(e.target.value);
        ValidatePhone(e.target.value);
    };

    const [brandNameValidation, setBrandNameValidation] = useState({
        isValid: true,
        message: "",
    });

    const [cityValidation, setCityValidation] = useState({
        isValid: true,
        message: "",
    });
    const [stateValidation, setStateValidation] = useState({
        isValid: true,
        message: "",
    });
    const [addressLine1Validation, setAddressLine1Validation] = useState({
        isValid: true,
        message: "",
    });
    const [zipCodeValidation, setZipCodeValidation] = useState({
        isValid: true,
        message: "",
    });

    const [phoneValidation, setPhoneValidation] = useState({
        isValid: true,
        message: "",
    });
    const [faxValidation, setFaxValidation] = useState({
        isValid: true,
        message: "",
    });

    const ValidateBrandName = (value) => {
        if (!value.trim()) {
            setBrandNameValidation({
                isValid: false,
                message: "Company name is required",
            });
            return false;
        } else if (value.length > 50) {
            setBrandNameValidation({
                isValid: false,
                message: "Name not more than 50 character",
            });
            return false;
        } else {
            setBrandNameValidation({
                isValid: true,
                message: "",
            });
            return true;
        }
    };

    const ValidateCity = (value) => {
        if (!value.trim()) {
            setCityValidation({
                isValid: false,
                message: "City is required",
            });
            return false;
        } else if (value.length > 50) {
            setCityValidation({
                isValid: false,
                message: "City not more than 50 character",
            });
            return false;
        } else {
            setCityValidation({
                isValid: true,
                message: "",
            });
            return true;
        }
    };

    const ValidateState = (value) => {
        if (!value.trim()) {
            setStateValidation({
                isValid: false,
                message: "State is required",
            });
            return false;
        } else {
            setStateValidation({
                isValid: true,
                message: "",
            });
            return true;
        }
    };

    const ValidateAddressLine = (value) => {
        if (!value.trim()) {
            setAddressLine1Validation({
                isValid: false,
                message: "Address is required",
            });
            return false;
        } else if (value.length > 50) {
            setAddressLine1Validation({
                isValid: false,
                message: "Address not more than 50 character",
            });
            return false;
        } else {
            setAddressLine1Validation({
                isValid: true,
                message: "",
            });
            return true;
        }
    };
    const ValidateZipCode = (value) => {
        if (!value.trim()) {
            setZipCodeValidation({
                isValid: false,
                message: "Postal code is required",
            });
            return false;
        } else if (!/^\d{5}$/.test(value)) {
            setZipCodeValidation({
                isValid: false,
                message: "Please enter a valid postal code",
            });
            return false;
        } else {
            setZipCodeValidation({
                isValid: true,
                message: "",
            });
            return true;
        }
    };

    const ValidatePhone = (value) => {
        if (!value.trim()) {
            setPhoneValidation({
                isValid: false,
                message: "Phone is required",
            });
            return false;
        } else if (value.replace(/\D/g, "").length < 10) {
            setPhoneValidation({
                isValid: false,
                message: "Enter a valid phone",
            });
            return false;
        } else {
            setPhoneValidation({
                isValid: true,
                message: "",
            });
            return true;
        }
    };

    const ValidateFax = (value) => {
        if (value && value.replace(/\D/g, "").length < 10) {
            setFaxValidation({
                isValid: false,
                message: "Enter a valid fax",
            });
            return false;
        } else {
            setFaxValidation({
                isValid: true,
                message: "",
            });
            return true;
        }
    };

    const updateBranding = async () => {
        ValidateAddressLine(address);
        ValidateCity(city);
        ValidateState(state);
        ValidateZipCode(zipCode);
        ValidateFax(fax);
        ValidatePhone(phone);
        ValidateBrandName(brandName);
        if (
            !ValidateAddressLine(address) ||
            !ValidateCity(city) ||
            !ValidateState(state) ||
            !ValidateZipCode(zipCode) ||
            !ValidatePhone(phone) ||
            !ValidateFax(fax) ||
            !ValidateBrandName(brandName)
        ) {
            return;
        }
        const itemData = {
            id,
            name: brandName,
            subtitle,
            logo: logoFile ? logo : null,
            address,
            city,
            state,
            zipCode,
            phone,
            onlinePayment: onlinePayment ? onlinePayment : false,
            fax,
            connectedAccountId: connectedAccountId ? connectedAccountId : "",
        };

        try {
            if (isUpdating) {
                await BrandingService.UpdateBranding(itemData).then((response) => {
                    if (response.status) {
                        notification.success({
                            message: "Org updated successfully",
                            icon: <CheckCircleOutlined style={{ color: "var(--primary)" }} />,
                        });
                    }
                });
            } else {
                await BrandingService.AddBranding(itemData).then((response) => {
                    if (response.status) {
                        notification.success({
                            message: "Org added successfully",
                            icon: <CheckCircleOutlined style={{ color: "var(--primary)" }} />,
                        });
                    }
                });
            }
            fetchBranding(); // Refresh branding data after update
        } catch (error) {
            console.error("Error updating branding:", error);
        }
    };

    return (
        <BrandingContext.Provider
            value={{
                brandName,
                setBrandName,
                subtitle,
                existingLogo,
                logo,
                logoFile,
                address,
                city,
                state,
                zipCode,
                phone,
                setSubtitle,
                setAddress,
                setCity,
                setState,
                setZipCode,
                setPhone,
                fax,
                setFax,
                handleFaxChange,
                handleSubtitleChange,
                handleAddressChange,
                handleCityChange,
                handleStateChange,
                handleZipCodeChange,
                handlePhoneChange,
                handleBrandNameChange,
                handleLogoChange,
                updateBranding,
                fetchBranding,
                isUpdating,
                cityValidation,
                stateValidation,
                zipCodeValidation,
                addressLine1Validation,
                phoneValidation,
                faxValidation,
                brandNameValidation,
                handleOnlinePaymentChange,
                onlinePayment,
                connectedAccountId,
                handleConnectedAccountIdChange,
            }}
        >
            {children}
        </BrandingContext.Provider>
    );
};

export const useBranding = () => {
    return useContext(BrandingContext);
};
